<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.partnerCompanyId == undefined && $route.name != 'NewPartnerCompany'"
      @Added="onCreated">

      <!-- no filters or sorting -->

      <template v-slot:list :pk="pk">
        <ListPane :getListMethod="getPartnerCompanyList" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="false" :show-sorting-tab="false" :itemsPerPage="50" ref="ListPane" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="openItem(item)"></ListItem>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/views/admin/partnercompany/PartnerCompanyListItem.vue";

export default {
  name: "AdminPartnerCompanyList",
  props: {},
  components: {
    ListPane,
    Layout,
    ListItem,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "WTL-",
    };
  },

  mounted() { },

  methods: {
    handleadded(item) {
      this.$refs.ListPane.handleadded(item);
    },
    handlechanged(item) {
      this.$refs.ListPane.handlechanged(item);
    },

    onCreated(item) {
      this.handleadded(item);
      this.openItem(item);
    },

    openItem(item) {
      var query = (this.$route.name == "PartnerCompanies") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewPartnerCompany', params: { partnerCompanyId: item.Id }, query })
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
        };
        return filters;
      }
      else {
        return null;
      }
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>